import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { unit, unitless } from "./utils/unit";
import parseUnit from "parse-unit";
var defaultFonts = ["Merriweather", "Georgia", "sans-serif"];
var baseFontSize = "16px"; // 16px converts to 100% at instantiation

var baseFontSizeDesktop = "18px";
var base = unitless(baseFontSize);
var baseDesktop = 112.5; // different from Gutenberg because it treats leading differently with Typographyjs

var lineHeight = 1.625;
var lineHeightDesktop = 1.7;
var leading = Math.ceil(base * lineHeight);
var leadingDesktop = Math.ceil(base * lineHeightDesktop);
var baseLineHeight = lineHeightDesktop;
var maxWidth = "35rem";
var colorFontBody = "#222";
var colorFontHeadings = colorFontBody;
var colorFontLight = "#888";
var colorFontFigcaption = colorFontBody;
var googleFonts = [{
  name: "Merriweather",
  styles: ["400", "400i", "700", "700i"]
}],
    headerFontFamily = [],
    bodyFontFamily = [];
bodyFontFamily.push.apply(bodyFontFamily, defaultFonts);
headerFontFamily = bodyFontFamily;

var getHeadingSizes = function getHeadingSizes(arr) {
  var ratio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return {
    fontSize: arr[0] * ratio * base + "px",
    lineHeight: arr[1] * ratio * leading + "px",
    marginTop: arr[2] * ratio * leading + "px",
    marginBottom: arr[3] * ratio * leading + "px"
  };
};

var getHeadings = function getHeadings(ratio) {
  return (
    /** used for desktop */
    {
      h1: _objectSpread({}, getHeadingSizes([2.5, 2, 4, 1], ratio)),
      h2: _objectSpread({}, getHeadingSizes([1.6875, 1.5, 2.5, 0.5], ratio)),
      h3: _objectSpread({}, getHeadingSizes([1.375, 1, 2, 0.5], ratio)),
      h4: _objectSpread({}, getHeadingSizes([1.2, 1, 1.5, 0.5], ratio)),
      h5: _objectSpread({}, getHeadingSizes([1, 1, 2.5, 0.5], ratio)),
      h6: _objectSpread({}, getHeadingSizes([1, 1, 2.5, 0.5], ratio))
    }
  );
};

var mediaString = "@media screen and (min-width: ".concat(unitless(maxWidth) + 5, "rem)");
var gutenbergMerriweather = {
  includeNormalize: true,
  title: "gutenberg-merriweather",
  googleFonts: googleFonts,
  headerFontFamily: headerFontFamily,
  bodyFontFamily: bodyFontFamily,
  overrideStyles: function overrideStyles(_ref, options) {
    var _objectSpread2;

    var adjustFontSizeTo = _ref.adjustFontSizeTo,
        rhythm = _ref.rhythm,
        establishBaseline = _ref.establishBaseline;
    return _objectSpread(_objectSpread({
      html: {
        // https://github.com/matejlatin/Gutenberg/blob/master/src/style/layout/_base.scss#L16
        fontSize: baseFontSize,
        fontFamily: defaultFonts.join(", "),
        color: colorFontBody,
        "-ms-text-size-adjust": "100%",
        "-webkit-text-size-adjust": "100%"
      },
      body: {
        boxSizing: "border-box"
      },
      "*": {
        lineHeight: rhythm(1),
        marginBottom: rhythm(1)
      }
    }, getHeadings()), {}, (_objectSpread2 = {
      "h1 + h2": {
        marginTop: rhythm(1)
      },
      "h2 + h3, h3 + h4, h4 + h5": {
        marginTop: rhythm(0.5)
      },
      "h5 + h6": {
        marginTop: rhythm(-0.5)
      },
      h6: {
        fontStyle: "italic",
        fontWeight: "normal"
      },

      /**
       * anchors
       * https://github.com/matejlatin/Gutenberg/blob/master/src/style/modules/_anchor.scss
       */
      a: {
        background: "transparent",
        color: colorFontBody,
        transition: "all .3s"
      },
      "a:active, a:hover": {
        outline: 0
      },
      "a:visited": {
        color: colorFontLight
      },
      "a:hover": {
        color: colorFontBody
      },
      "a:active": {
        color: "#f00"
      },
      "h1 a, h2 a, h3 a, h4 a, h5 a, h6 a": {
        textDecoration: "none"
      },
      "h1 a:visited, h2 a:visited, h3 a:visited, h4 a:visited, h5 a:visited, h6 a:visited": {
        color: colorFontBody
      },

      /**
       * attention grabber
       * not really present in Gatsby sites
       */
      ".attention-grabber": _objectSpread(_objectSpread({}, adjustFontSizeTo("120%")), {}, {
        lineHeight: rhythm(1.2)
      }),

      /**
       * figure and figcaption
       * not compiled to from markdown remark
       */
      figure: {
        display: "block"
      },
      figcaption: {
        lineHeight: rhythm(1),
        color: colorFontFigcaption,
        display: "block",
        fontSize: ".8125rem",
        fontStyle: "italic",
        marginBottom: 0,
        textAlign: "center"
      },
      img: {
        border: 0,
        maxWidth: "100%",
        display: "block",
        margin: "inherit auto"
      },
      ".floatRight": {
        float: "right"
      },
      ".floatLeft": {
        float: "left"
      },

      /**
       * horizontal rules
       * https://github.com/matejlatin/Gutenberg/blob/master/src/style/modules/_horizontal-rule.scss
       */
      hr: {
        marginTop: "".concat(leading * 2, "px"),
        marginBottom: "".concat(leading * 2, "px"),
        boxSizing: "content-box",
        border: 0,
        color: colorFontBody,
        display: "block",
        height: leading + "px",
        marginRight: "auto",
        marginLeft: "auto",
        textAlign: "center",
        background: "transparent"
      },
      "hr::before": {
        content: "'***'",
        letterSpacing: "0.2em"
      },
      blockquote: {
        fontStyle: "italic",
        paddingLeft: "1.4375rem"
        /**
         * TODO: add figure blockquote
         * https://github.com/matejlatin/Gutenberg/blob/25ba870789/src/style/modules/_quote.scss#L18
         */

      }
    }, _defineProperty(_objectSpread2, mediaString, _objectSpread({
      html: {
        fontSize: baseFontSizeDesktop
      },
      "article *, main *, footer": {
        maxWidth: maxWidth,
        marginLeft: "auto",
        marginRight: "auto",

        /**
         * TODO
         * this is not right likely due to rounding, need to fix
         * https://github.com/matejlatin/Gutenberg/blob/master/src/style/layout/_base.scss#L37
         */
        lineHeight: lineHeightDesktop
      },
      "figure.floatLeft, figure.floatRight": {
        // TODO: fix float left and right styling
        lineHeight: lineHeightDesktop,
        maxWidth: unitless(maxWidth) * 0.5 + "rem",
        padding: "0 ".concat(rhythm(1))
      },

      /**
       * main is not present in gutenberg, added for site styling
       */
      "article, main": {
        maxWidth: unitless(maxWidth) * 1.5 + "rem",
        marginLeft: "auto",
        marginRight: "auto"
      },
      blockquote: {
        paddingLeft: "2rem"
      },
      hr: {
        marginTop: "".concat(leadingDesktop * 2, "px"),
        marginBottom: "".concat(leadingDesktop * 2, "px")
      }
    }, getHeadings(baseDesktop / 100))), _defineProperty(_objectSpread2, "body", {
      padding: 0
    }), _defineProperty(_objectSpread2, ".anchor", {
      marginLeft: "-20px !important"
    }), _defineProperty(_objectSpread2, ".anchor svg", {
      marginBottom: ".1em"
    }), _objectSpread2));
  }
};
export default gutenbergMerriweather;